import * as React from 'react'
import { Col, Row, Button } from 'antd'
import { useIntl } from 'react-intl'
import { isMobile, isIOS } from 'react-device-detect'
import classNames from 'classnames'
import styles from './PoweredBy.module.scss'
import logo from '../../assets/img/gett_delivery_wide.png'
import * as AnalyticsManager from '../../lib/analytics/analytics'
import { AnalyticsEvent } from '../../lib/analytics/events'
import { ReactComponent as AppleIcon } from '../../assets/img/apple_icon.svg'
import { ReactComponent as GoogleIcon } from '../../assets/img/google-play_icon.svg'

interface PoweredByProps {
  downloadButtonEnabled: boolean
}

const PoweredBy = ({ downloadButtonEnabled }: PoweredByProps) => {
  const { formatMessage } = useIntl()
  const translate = (id: string, values: any = {}) => formatMessage({ id }, values)

  const onLogoClick = () => {
    AnalyticsManager.sendEvent(AnalyticsEvent.LogoClick)
  }

  const onButtonClick = () => {
    AnalyticsManager.sendEvent(AnalyticsEvent.DownloadButton)
  }

  const logoClasses = {
    [styles.isMobile]: isMobile,
  }

  return (
    <Row>
      <Col xs={24}>
        <div className={styles.poweredBy}>{translate('delivery_by')}</div>
      </Col>
      <Col xs={24}>
        <a
          href={translate('branch_io_link')}
          className={classNames(styles.companyLogo, logoClasses)}
          onClick={onLogoClick}
          target='_blank'
          rel="noopener noreferrer"
        >
          <img className={styles.companyLogo} src={logo} alt="Logo" />
        </a>
      </Col>
      {isMobile && downloadButtonEnabled &&
        <Col xs={24}>
          <a
            href={translate('branch_io_link')}
            target='_blank'
            rel="noopener noreferrer"
          >
            <Button
                className={classNames(styles.downloadButton)}
                onClick={onButtonClick}
            >
              {isIOS ? <AppleIcon /> : <GoogleIcon />}
              {translate('get_app')}
            </Button>
          </a>
        </Col>
      }
    </Row>
  )
}

export default PoweredBy
